import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { GasIcon } from "../core/icons/Icons";
import { NumberInput } from "../core/NumberField";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles, InputLabel } from "@material-ui/core";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const NewConnectionGasDemandForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues } = useFormModel<ChangeNames.NEW_CONNECTION_GAS_DEMAND>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<GasIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Gasnennwärmeleistung
                        </p>
                        <p className={classes2.pText} style={{ marginTop: 0, marginBottom: 24 }}>
                            Geben Sie die Gasnennwärmeleistung an. Die benötigte Leistung erhalten
                            Sie ggf. von Ihrem Heizungsinstallateur/Architekten.
                        </p>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Summe der Gasnennwärmeleistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.newConnectionGasDemand.value.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.newConnectionGasDemand.value.unit}
                            value={values.newConnectionGasDemand.value.amount.num || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.newConnectionGasDemand.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={values.newConnectionGasDemand.error !== null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
